module.exports = __webpack_public_path__ + "static/media/1.d13e31c7.svg";